// extracted by mini-css-extract-plugin
export default {"main":"CommunicationsPanel_main__DlU8O","sort":"CommunicationsPanel_sort__Wb3eO","active":"CommunicationsPanel_active__LeBYU"};